import { gsap } from 'gsap';

class DefaultTransition {
	name = 'default-transition';

	$loader = $('[data-loader="el"]');
	$logo = $('[data-loader="logo"]');

	once() {
		// create your one-time animation here
		$('html').addClass('no-scroll');

		const tl = gsap.timeline();

		tl.to(this.$logo, {
			opacity: 1,
			duration: 1.5,
			delay: 0.25,
		});

		tl.to(this.$loader, {
			opacity: 0,
			duration: 1,
			delay: 0.25,
			onComplete: () => {
				$('html').removeClass('no-scroll');
				this.$loader.remove();
			},
		});
	}
	leave() {
		// create your stunning leave animation here
	}
	enter() {
		// create your amazing enter animation here
	}
}

export default new DefaultTransition();
